module.exports = __webpack_public_path__ + "img/changeLang.f90579fd.png";